import { isDispenseKioskMode } from '@/utils/kiosk'
import { safeFetchAPI, SafeFetchResponse } from '../index'
import {
  RecommendationRequest,
  MenuType,
  InhalableRecommendationResponse,
  EdibleRecommendationResponse,
} from '../../types/widget'
import { API_BASE } from './index'

// Callback type for getRecommendations
export type GetRecommendationsCallback = (
  uid: string,
  globalId: string,
  menuType: MenuType,
  payload: RecommendationRequest
) => Promise<SafeFetchResponse<InhalableRecommendationResponse | EdibleRecommendationResponse>>

function recommendQueryParams(): { kiosk: true } | undefined {
  return isDispenseKioskMode() ? { kiosk: true } : undefined
}

export async function getInhalableRecommendations(
  uid: string,
  globalId: string,
  menuType: MenuType,
  payload: RecommendationRequest
): Promise<SafeFetchResponse<InhalableRecommendationResponse>> {
  return safeFetchAPI<InhalableRecommendationResponse>(
    `${API_BASE}/widget/recommend/inhalable/${uid}/${globalId}/${menuType}`,
    {
      method: 'POST',
      payload,
      queryParams: recommendQueryParams(),
    }
  )
}

export async function getScentRecommendations(
  uid: string,
  globalId: string,
  menuType: MenuType,
  payload: RecommendationRequest
): Promise<SafeFetchResponse<InhalableRecommendationResponse>> {
  return safeFetchAPI<InhalableRecommendationResponse>(
    `${API_BASE}/widget/recommend/scent/${uid}/${globalId}/${menuType}`,
    {
      method: 'POST',
      payload,
      queryParams: recommendQueryParams(),
    }
  )
}

export async function getEdibleRecommendations(
  uid: string,
  globalId: string,
  menuType: MenuType,
  payload: RecommendationRequest
): Promise<SafeFetchResponse<EdibleRecommendationResponse>> {
  return safeFetchAPI<EdibleRecommendationResponse>(
    `${API_BASE}/widget/recommend/edible/${uid}/${globalId}/${menuType}`,
    {
      method: 'POST',
      payload,
      queryParams: recommendQueryParams(),
    }
  )
}
